import { filterProps } from '@/utils/functional-component-utils';
import get from 'lodash/get';

const flattenAttributes = (attributes, children, convertToObject) => {
  if (attributes) {
    return attributes.reduce((result, item) => {
      return [
        ...result,
        convertToObject(item),
        ...flattenAttributes(get(item, children), children, convertToObject)
      ];
    }, []);
  } else {
    return [];
  }
};

export default {
  props: {
    itemChildren: { type: String, default: 'data.children' },
    overrideFlatObject: undefined
  },
  computed: {
    flatItems() {
      if (this.lazyItems.length === 0) return []
      return flattenAttributes(this.lazyItems, this.itemChildren, this.convertToObject);
    },
    filterProp() {
      return filterProps(this.$props, ['lazyItems', 'value', 'menuProps']);
    },
  },
  methods: {
    filterProps: filterProps,
    convertToObject(item) {
      if (this.overrideFlatObject) {
        return this.overrideFlatObject(item);
      }
      return {
        id: get(item, this.$props.itemValue),
        label: get(item, this.$props.itemText)
      }
    },
  }
};
